<div class="ai-settings">
    <div class="panel">
        <div class="panel-header">
            <h1>Travel Buddy Settings | Knowledge Bank</h1>
            <upgrade-button *ngIf="!isLoading" [show]="!aiSettings.travelBuddy.isActive" [css]="'upgrade-btn'">
            </upgrade-button>
        </div>

        <ig-spinner *ngIf="isLoading"></ig-spinner>

        <ng-container *ngIf="!isLoading && aiSettings.travelBuddy.isActive">
            <div>
                <p>You can upload files for travel buddy to learn</p>
                <p>Supported file types are <strong>pdf</strong>, <strong>doc</strong>, <strong>docx</strong>,
                    <strong>txt</strong>, <strong>pptx</strong> and <strong>md</strong>
                </p>

                <ig-file-selector [disabled]="false" accept=".pdf,.doc,.docx,.pptx,.txt,.md" [multiple]="true"
                    (onRead)="fileRead($event)"></ig-file-selector>

                <div class="file-wrap half-width m-t-2">
                    <p *ngFor="let file of selectedFiles" class="flex items-center gap-2">
                        <mat-icon matTooltip="remove" (click)="removeFile(file)">clear
                        </mat-icon>
                        {{ file.name }}
                    </p>

                    <ig-button class="m-t-2" *ngIf="selectedFiles.length" [isAsync]="true"
                        (trigger)="uploadTravelBuddyClientFiles($event)">Upload
                    </ig-button>
                </div>
            </div>

            <div class="m-t-3">
                <strong>Uploaded files:</strong>
                <ig-spinner *ngIf="isLoadingClinetUploadedFiles" class="m-t-1"></ig-spinner>
                <p *ngIf="!clientUploadedFiles.length && !isLoadingClinetUploadedFiles" class="light-gray-text m-t-1">
                    You don't have uploaded files
                </p>

                <ig-list *ngIf="clientUploadedFiles.length && !isLoadingClinetUploadedFiles">
                    <div header>
                        <ig-list-column-header>
                            <ig-row>
                                <ig-col [xs]="10" [md]="8">File name / link</ig-col>
                                <ig-col [xs]="10" [md]="3">Upload Time</ig-col>
                            </ig-row>
                        </ig-list-column-header>
                    </div>

                    <div body>
                        <ig-list-item *ngFor="let file of clientUploadedFiles">
                            <ig-row class="relative">
                                <ig-col [xs]="10" [md]="8">
                                    <div>{{ file.link || file.name }}</div>
                                    <div class="failed-status">{{ file.lastError ? file.lastError.message : '' }}</div>
                                </ig-col>
                                <ig-col [xs]="10" [md]="3">{{ toLocalTime(file.uploadedAt) }}</ig-col>
                            </ig-row>
                            <ig-row-action-buttons style="max-width: 0">
                                <mat-icon matTooltip="Delete" (click)="deleteFile(file)">
                                    clear
                                </mat-icon>
                            </ig-row-action-buttons>
                        </ig-list-item>
                    </div>
                </ig-list>
            </div>

            <div class="m-t-3 extract-link-wrap">
                <hr>
                <strong class="m-t-3">Or, extract content from a link:</strong>

                <div class="flex gap-2">
                    <ig-field [formControl]="form.get('link')"></ig-field>
                    <ig-button [isAsync]="true" size="md" (trigger)="extractLink($event)">GO</ig-button>
                </div>

                <mat-checkbox [(ngModel)]="isIncludeLinks">Include Linked Pages
                </mat-checkbox>

                <div *ngIf="!isExtracting && failedLinksArr && failedLinksArr.length > 0" class="red-text">
                    <p>Failed to extract content from the following links:</p>
                    <div *ngFor="let link of failedLinksArr" class="failed-link-item">
                        {{ link }}
                    </div>
                </div>

                <div *ngIf="isExtracting && isIncludeLinks" class="flex gap-2 items-center m-t-3 extract-tip">
                    <mat-icon class="ig-spin" style="font-size:16px;width:16px;height:16px">autorenew</mat-icon>
                    <span *ngIf="!linkContent.length">Extracting content...</span>
                    <span *ngIf="linkContent.length">{{ linkContent[0].links.length }} links found in the original link,
                        parsing No.{{ linkContent.length + 1 }} link...</span>
                </div>

                <div *ngIf="!isExtracting " class="flex justify-between items-center relative"
                    style="width:795px;top:28px">
                    <p *ngIf="linkContent.length" style="margin-bottom:-20px">
                        {{ linkContent.length }} pages extracted:</p>
                    <ig-button *ngIf="linkContent.length && !isUploadLinkContentEnded" [disabled]="!getIsChecked()"
                        size="md" [isAsync]="true" (trigger)="uploadExtractedContent($event)">
                        Upload selected content
                    </ig-button>
                </div>

                <div class="link-content-area">

                    <div *ngFor="let data of linkContent;let i = index" class="flex flex-col relative"
                        [class.m-t-6]="i">
                        <div class="flex gap-2 items-center">
                            <mat-checkbox [(ngModel)]="data.checked"></mat-checkbox>
                            <a [href]="data.oriLink" target="_blank">{{ data.oriLink }}</a>
                        </div>
                        <div *ngIf="linkExists(data.oriLink)">This page has been uploaded</div>
                        <textarea cols="30" rows="10" [(ngModel)]="data.content"
                            [disabled]="!data.checked || linkExists(data.oriLink)" class="m-t-1"></textarea>

                        <div *ngIf="data.status !== 'initial'"
                            class="absolute flex flex-col items-center justify-center link-content-upload">

                            <div class="flex flex-col items-center justify-center "
                                style="background:white;padding:12px;border:1px solid lightgray;transform:translateX(-20px)">
                                <ng-container *ngIf="data.status === 'uploading'">
                                    <mat-icon style="background:deepskyblue">autorenew</mat-icon>
                                    <p>Uploading content...</p>
                                </ng-container>

                                <ng-container *ngIf="data.status === 'uploaded'">
                                    <mat-icon style="background:green">check
                                    </mat-icon>
                                    <p>Uploaded</p>
                                </ng-container>
                                <ng-container *ngIf="data.status === 'error'">
                                    <mat-icon style="color:red">error</mat-icon>
                                    <p>Error</p>
                                </ng-container>
                            </div>


                        </div>
                    </div>
                </div>

            </div>
        </ng-container>


    </div>


    <div class="panel">
        <div class="panel-header">
            <h1>Travel Buddy Settings | Interface Customization</h1>
            <upgrade-button *ngIf="!isLoading" [show]="!aiSettings.travelBuddy.isActive" [css]="'upgrade-btn'">
            </upgrade-button>
        </div>

        <ig-spinner *ngIf="isLoading"></ig-spinner>

        <ng-container *ngIf="!isLoading && aiSettings.travelBuddy.isActive">
            <div class="flex gap-4">
                <div style="width:60%">
                    <mat-accordion>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Logo
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                                <div>Logo url or title text</div>
                                <div class="flex gap-2">
                                    <ig-field [formControl]="form.get('logo')" (onKeyPressUp)="logoTextKeyup($event)"
                                        [(ngModel)]="aiSettings.travelBuddy.ui.logo"></ig-field>
                                    <div style="width: 100px;text-align: center;position: relative;top:12px;left:6px">Or
                                    </div>
                                    <ig-image-selector #imgSelector label="Upload logo" [command]="command"
                                        [updateLabel]="''" (onImageChanged)="onImageChange($event)"
                                        [selectedImageData]="logoImgData" [class.img-selected]="!!logoImgData">
                                    </ig-image-selector>
                                </div>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Color
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="flex gap-2 m-t-1">
                                <div>
                                    <div>Gradient from</div>
                                    <input [value]="aiSettings.travelBuddy.ui.color.from"
                                        [style.background]="aiSettings.travelBuddy.ui.color.from"
                                        [cpCancelButton]="true" (colorPickerChange)="chooseColor()"
                                        [(colorPicker)]="aiSettings.travelBuddy.ui.color.from" cpPosition="right" />
                                    <div href="#" (click)="aiSettings.travelBuddy.ui.color.from='#275585'"
                                        style="font-size:12px;color:dodgerblue;cursor:pointer">back to default
                                    </div>
                                </div>
                                <div>
                                    <div>To</div>
                                    <input [value]="aiSettings.travelBuddy.ui.color.to"
                                        [style.background]="aiSettings.travelBuddy.ui.color.to" [cpCancelButton]="true"
                                        (colorPickerChange)="chooseColor()"
                                        [(colorPicker)]="aiSettings.travelBuddy.ui.color.to" cpPosition="right" />
                                    <div href="#" (click)="aiSettings.travelBuddy.ui.color.to='#50b4d1'"
                                        style="font-size:12px;color:dodgerblue;cursor:pointer">back to default
                                    </div>
                                </div>
                            </div>
                            <div class="flex gap-2 m-b-5 m-t-1">
                                <div>
                                    <div>Name</div>
                                    <input [value]="aiSettings.travelBuddy.ui.color.name"
                                        [style.background]="aiSettings.travelBuddy.ui.color.name"
                                        [cpCancelButton]="true" (colorPickerChange)="chooseColor()"
                                        (change)="chooseColor($event)"
                                        [(colorPicker)]="aiSettings.travelBuddy.ui.color.name" cpPosition="right" />
                                    <div href="#" (click)="aiSettings.travelBuddy.ui.color.name='#ffd700'"
                                        style="font-size:12px;color:dodgerblue;cursor:pointer">back to default
                                    </div>
                                </div>
                                <div>
                                    <div>Text</div>
                                    <input [value]="aiSettings.travelBuddy.ui.color.text"
                                        [style.background]="aiSettings.travelBuddy.ui.color.text"
                                        [cpCancelButton]="true" (colorPickerChange)="chooseColor()"
                                        (change)="chooseColor($event)"
                                        [(colorPicker)]="aiSettings.travelBuddy.ui.color.text" cpPosition="right" />
                                    <div href="#" (click)="aiSettings.travelBuddy.ui.color.text='#ffffff'"
                                        style="font-size:12px;color:dodgerblue;cursor:pointer">back to default
                                    </div>
                                </div>
                                <div>
                                    <div>Toggle icon</div>
                                    <input [value]="aiSettings.travelBuddy.ui.color.toggleIcon"
                                        [style.background]="aiSettings.travelBuddy.ui.color.toggleIcon"
                                        [cpCancelButton]="true" (colorPickerChange)="chooseColor()"
                                        (change)="chooseColor($event)"
                                        [(colorPicker)]="aiSettings.travelBuddy.ui.color.toggleIcon"
                                        cpPosition="right" />
                                    <div href="#" (click)="aiSettings.travelBuddy.ui.color.toggleIcon='#233451'"
                                        style="font-size:12px;color:dodgerblue;cursor:pointer">back to default
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Avatar
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                                <div>Name</div>
                                <ig-field [formControl]="form.get('avatarName')" placeholder="AI Travel Buddy"
                                    [(ngModel)]="aiSettings.travelBuddy.ui.avatar.name"></ig-field>
                                <div>Profile Image</div>
                                <ig-field [formControl]="form.get('avatarProfile')" placeholder="AI Travel Buddy"
                                    [(ngModel)]="aiSettings.travelBuddy.ui.avatar.profile"></ig-field>
                                <div>Thumbnail</div>
                                <ig-field [formControl]="form.get('avatarThumbnail')" placeholder="AI Travel Buddy"
                                    [(ngModel)]="aiSettings.travelBuddy.ui.avatar.thumbnail"></ig-field>
                                <div>Intro</div>
                                <ig-field [formControl]="form.get('avatarIntro')"
                                    placeholder="Intro text of TravelBuddy"
                                    [(ngModel)]="aiSettings.travelBuddy.ui.avatar.intro"></ig-field>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Default Questions
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                                <p class="m-t-1">Question 1</p>
                                <ig-field [formControl]="form.get('defaultQuestion1')"
                                    placeholder="What are some must-see attractions in {{aiSettings.travelBuddy.cityName || 'Savannah, GA'}}?"
                                    [(ngModel)]="aiSettings.travelBuddy.ui.questions[0]"></ig-field>
                                <p>Question 2</p>
                                <ig-field [formControl]="form.get('defaultQuestion2')"
                                    placeholder="Please suggest a 2-day itinerary in {{aiSettings.travelBuddy.cityName || 'Savannah, GA'}}."
                                    [(ngModel)]="aiSettings.travelBuddy.ui.questions[1]"></ig-field>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Introduction
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                                <p>Title</p>
                                <ig-field [formControl]="form.get('introTitle')"
                                    placeholder="About {{aiSettings.travelBuddy.cityName || 'Savannah, GA'}}."
                                    [(ngModel)]="aiSettings.travelBuddy.ui.introduction.title"></ig-field>
                                <p>Image</p>
                                <ig-field [formControl]="form.get('introImage')" placeholder="Image Url"
                                    [(ngModel)]="aiSettings.travelBuddy.ui.introduction.imageUrl"></ig-field>
                                <p>Content</p>
                                <ig-field [formControl]="form.get('introContent')"
                                    placeholder="{{aiSettings.travelBuddy.cityName || 'Savannah, GA'}} is a captivating city"
                                    [(ngModel)]="aiSettings.travelBuddy.ui.introduction.content"></ig-field>
                            </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    Other Information
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div>
                                <p>Privacy Policy Link</p>
                                <ig-field [formControl]="form.get('privacyPolicyLink')"
                                    [(ngModel)]="aiSettings.travelBuddy.ui.otherInfo.privacyPolicyLink"></ig-field>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <ig-button [isAsync]="true" size="md" (trigger)="saveUI($event)" style="width:120px" class="m-t-3">
                        Save
                    </ig-button>
                </div>
                <div style="margin-left:24px;margin-top:-46px;font-family:Roboto, sans-serif">

                    <div class="relative"
                        style="width: 325px;border-radius:8px;padding:12px 20px 20px;max-height:560px;overflow-y:auto"
                        [style.backgroundImage]="'linear-gradient(to bottom, '+aiSettings.travelBuddy.ui.color.from+', '+aiSettings.travelBuddy.ui.color.to+')'">
                        <div [style.color]="aiSettings.travelBuddy.ui.color.text">
                            <div style="font-family:monospace;display:flex;justify-content:flex-end">
                                <img *ngIf="isImg" [src]="logoImgData||aiSettings.travelBuddy.ui.logo" alt=""
                                    style="height:32px;">
                                <div *ngIf="!isImg">{{
                                    aiSettings.travelBuddy.ui.logo ||
                                    hubName
                                    }}
                                </div>
                            </div>

                            <div style="display:flex;gap:20px;margin-top:12px">
                                <img [src]="aiSettings.travelBuddy.ui.avatar.profile || 'https://iti-images.s3.amazonaws.com/imgs/bot.png'"
                                    alt="" style="width:70px;object-fit:contain">

                                <div style="display:flex;flex-direction:column;justify-content:flex-end">
                                    <div style="font-size:24px;font-weight:600;">Hi, there, I'm your
                                    </div>
                                    <div style="font-size:24px;font-weight:600"
                                        [style.color]="aiSettings.travelBuddy.ui.color.name">
                                        {{ aiSettings.travelBuddy.ui.avatar.name || 'AI Travel Buddy' }}
                                    </div>
                                </div>


                            </div>
                            <!-- <div style="margin-top:20px;font-size:18px;font-weight:600">Chat with me</div> -->
                            <div style="font-size:13px" class="m-t-1">
                                {{ aiSettings.travelBuddy.ui.avatar.intro }}
                            </div>
                        </div>

                        <div *ngIf="aiSettings.travelBuddy.ui.questions[0]"
                            style="border-radius:8px;background-color:#f8f8f8;padding:12px;margin-top:20px">
                            <div style="font-weight:600;color:gray;font-size:15px">You can ask me</div>
                            <div style="font-size:13px;color:rgb(71, 71, 71)" class="m-t-1">
                                {{ aiSettings.travelBuddy.ui.questions[0] }}
                            </div>
                        </div>
                        <div *ngIf="aiSettings.travelBuddy.ui.questions[1]"
                            style="border-radius:8px;background-color:#f8f8f8;padding:12px;margin-top:20px">
                            <div style="font-weight:600;color:gray;font-size:15px">Or, ask me</div>
                            <div style="font-size:13px;color:rgb(71, 71, 71)" class="m-t-1">
                                {{ aiSettings.travelBuddy.ui.questions[1] }}
                            </div>
                        </div>
                        <div class="flex justify-between items-center"
                            style="border-radius:8px;background-color:#f8f8f8;padding:12px;margin-top:20px;font-size:13px">
                            <span style="color:gray">Or, ask me anything about traveling</span>
                            <mat-icon style="color:deepskyblue">send</mat-icon>
                        </div>
                        <div *ngIf="hasIntroduction"
                            style="border-radius:8px;background-color:#f8f8f8;padding:12px;margin-top:20px">
                            <div style="font-weight:600;font-size:16px;color:gray">
                                {{ aiSettings.travelBuddy.ui.introduction.title }}
                            </div>
                            <img [src]="aiSettings.travelBuddy.ui.introduction.imageUrl" alt="" class="m-t-2 full-width"
                                style="border-radius:8px">
                            <div style="font-size:13px" class="m-t-1">
                                {{ aiSettings.travelBuddy.ui.introduction.content }}
                            </div>
                        </div>


                    </div>

                    <div style="border-radius:50%;width:50px;height:50px;margin-top:12px;float:right"
                        [style.background]="aiSettings.travelBuddy.ui.color.toggleIcon"
                        class="flex items-center justify-center">
                        <img [src]="aiSettings.travelBuddy.ui.avatar.thumbnail || 'https://iti-images.s3.amazonaws.com/imgs/bot-head-v.png'"
                            alt="" style="width:30px">
                    </div>
                </div>
            </div>

            <div class="panel-header prompt-settings">
                <h1>Travel Buddy Prompt</h1>

                <div class="flex">
                    <div style="width: 60%">
                        <div class="flex gap-4">
                            <mat-checkbox [(ngModel)]="aiSettings.travelBuddy.indicator.isEnabled">Show prompt
                            </mat-checkbox>
                            <mat-checkbox [(ngModel)]="aiSettings.travelBuddy.indicator.onlyShowOnce">Only show once
                            </mat-checkbox>
                            <mat-icon style="margin-left: -10px;color:lightgray"
                                matTooltip="No longer display the prompt once user opens TravelBuddy. Otherwise it will be displayed again if user reloads the page">
                                info
                            </mat-icon>
                        </div>
                        <ig-field [formControl]="form.get('prompt')" mode="textarea" maxLength="300" [maxlength]="'300'"
                            (onKeyPressUp)="promptTextKeyup($event)"
                            [disabled]="!aiSettings.travelBuddy.indicator.isEnabled"
                            [(ngModel)]="aiSettings.travelBuddy.indicator.prompt"></ig-field>

                        <ig-button class="m-t-2" style="width: 120px" [isAsync]="true" (trigger)="setIndicator($event)">
                            Save
                        </ig-button>
                    </div>
                    <div
                        style="width: 40%;display: flex;flex-direction: column;align-items: flex-end;padding-right: 5%">
                        <div [class.opacity-0]="!aiSettings.travelBuddy.indicator.isEnabled"
                            style="border-radius: 4px;width: 80%;padding:16px;transition:all 0.3s ease-in-out;box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;">
                            {{ form.get('prompt').value }}
                        </div>
                        <div style="border-radius:50%;width:50px;height:50px;margin-top:12px;float:right"
                            [style.background]="aiSettings.travelBuddy.ui.color.toggleIcon"
                            class="flex items-center justify-center">
                            <img [src]="aiSettings.travelBuddy.ui.avatar.thumbnail || 'https://iti-images.s3.amazonaws.com/imgs/bot-head-v.png'"
                                alt="" style="width:30px">
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>

    <div class="panel">
        <div class="panel-header">
            <h1>Travel Buddy Embedding Code</h1>

            <ul>
                <li>
                    <p>You can add travel-buddy="true" to turn on travel buddy for event/place widgets</p>
                </li>
                <li>
                    <p>Use travel-buddy-right="48px" or travel-buddy-left="48px", travel-buddy-bottom="32px" or
                        travel-buddy-top="32px" to set the position of the trigger icon (if you don't set them, by
                        default,
                        travel buddy will show on the bottom right corner)</p>
                </li>
            </ul>
            <div class="code-area">
                <pre>
                    <code>{{ getEmbedScript() }}</code>
                </pre>
                <mat-icon (click)="copyLink()" matTooltip="copy">
                    content_copy
                </mat-icon>
            </div>

            <ul class="m-t-6">
                <li>
                    <p>Use this code for only embedding travel buddy to your webpage, without event/place widgets</p>
                </li>
            </ul>
            <div class="code-area">
                <pre>
                    <code>{{ getOnlyTravelBuddyEmbedScript() }}</code>
                </pre>
                <mat-icon (click)="copyOnlyTravelBuddyLink()" matTooltip="copy">
                    content_copy
                </mat-icon>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/ai.settings/ai.settings.component.html